import { render, staticRenderFns } from "./AppLayoutContacts.vue?vue&type=template&id=36149be3&scoped=true"
import script from "./AppLayoutContacts.vue?vue&type=script&lang=js"
export * from "./AppLayoutContacts.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutContacts.vue?vue&type=style&index=0&id=36149be3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36149be3",
  null
  
)

export default component.exports